var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmex = function SvgAmex(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7692 17H3.23077C1.99827 17 1 16.2044 1 15.2222V2.77778C1 1.79556 1.99827 1 3.23077 1H27.7692C29.0017 1 30 1.79556 30 2.77778V15.2222C30 16.2044 29.0017 17 27.7692 17Z",
    stroke: "black",
    strokeWidth: 1.76923,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.057 6L13.5628 10.0495L12.0686 6H9.97676V11.7L7.8849 6H6.24074L4 12H5.34531L5.79412 10.6505H8.33478L8.78141 12H11.321V7.5L12.9651 12H14.1605L15.8046 7.65055V12H17V6H15.057ZM6.24074 9.3L6.98838 7.2L7.73602 9.3H6.24074Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8234 9L27 6H25.4029L23.9514 7.8L22.7903 6H18V12H22.6446L24.0961 10.0495L25.5475 12H27L24.8234 9ZM21.9205 10.8H19.1633V9.6H21.7759V8.4H19.1633V7.35055H22.0662L23.2273 9.00109L21.9205 10.8Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "amex.31dd11c8d922c8075af42f5e3b53fb94.svg";